module.exports = __webpack_public_path__ + "static/media/colheitadeira2.11abf593.svg";